import { BaseModel } from "./BaseModel";

export class Message extends BaseModel {
  schema = "/message";
  constructor(params) {
    return super(params, "/message");
  }
}
